export default {
    name: 'fertilizing',
    serverName: '/api/v1/fertilizing/fertilizing/',
    apiUrl: '/api/v1/fertilizing/fertilizing/',
    feedingApiUrl: '/api/v1/calculator/calculator_group/'
};
